import { render, staticRenderFns } from "./ProductTagList.vue?vue&type=template&id=116b1f26&"
import script from "./ProductTagList.vue?vue&type=script&lang=js&"
export * from "./ProductTagList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports